import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setCurrentContentReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<(string | number)[]>) => {
    state.currentContent = action.payload;
  });
};

export default setCurrentContentReducer;
